"use client";

import { Button } from "@/components/ui/button";
import { Plus, FolderOpen, Archive } from "lucide-react";

export function EmptySpacesState({ onCreateSpace, canCreateSpaces = true, isArchiveView = false }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="relative mb-6">
        <div className="h-20 w-20 rounded-full bg-gray-100 flex items-center justify-center">
          {isArchiveView ? (
            <Archive className="h-10 w-10 text-gray-400" />
          ) : (
            <FolderOpen className="h-10 w-10 text-gray-400" />
          )}
        </div>
      </div>

      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        {isArchiveView ? "No archived spaces" : "No spaces yet"}
      </h3>

      <p className="text-gray-500 text-center max-w-sm mb-6">
        {isArchiveView
          ? "You don't have any archived spaces. Archived spaces will appear here and can be restored at any time."
          : canCreateSpaces
            ? "Get started by creating your first space to organize your team's training and compliance."
            : "No spaces have been created yet. Contact your administrator to get started."
        }
      </p>

      {/* Only show create button when NOT in archive view */}
      {!isArchiveView && canCreateSpaces && (
        <Button
          onClick={onCreateSpace}
          className="bg-green-600 hover:bg-green-700 text-white"
        >
          <Plus className="h-4 w-4 mr-2" />
          New Space
        </Button>
      )}
    </div>
  );
}